import Atlas from "./AtlasApi";
import "./BrowserHostHelpers";
import "./LocalStorage";

import {
    dragDropHandler_registerDraggable, dragDropHandler_disposeDraggable, dragDropHandler_firstInitialization
} from "./DragDropHandler";

window.dragDropHandler = {
    disposeDraggable: dragDropHandler_disposeDraggable,
    registerDraggable: dragDropHandler_registerDraggable
}


await dragDropHandler_firstInitialization();
await Atlas.initialize(window._atlasConfigStart);

await Atlas.addAtlas("app");
